module.exports = __webpack_public_path__ + "static/media/Business Results.2fba0126.png";